import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';

export const ArchDrawioIcon = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    fill="currentColor"
  >
    <path d="M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z" />
  </svg>
);

export const page = PageBlueprint.make({
  params: {
    // The plugin id cannot carry a dot, so the package and the route stay
    // "arch-drawio" while the product name is only spelled out in the title.
    path: '/arch-drawio',
    routeRef: rootRouteRef,
    title: 'Arch Draw.io',
    icon: <ArchDrawioIcon />,
    loader: () =>
      import('./components/ArchDrawioBoard').then(m => <m.ArchDrawioPage />),
  },
});

export const archDrawioPlugin = createFrontendPlugin({
  pluginId: 'arch-drawio',
  extensions: [page],
  routes: {
    root: rootRouteRef,
  },
});
